import { Text } from '../../../../../cdl/Text/Text';
import { Tooltip } from '../../../../../cdl/Tooltip/Tooltip';
import { translate } from '../../../../../common/helpers/translate.helper';
import { useEnums } from '../../../../../common/hooks/useEnums';
import { usePaymentTermsFormat } from '../../../../../common/hooks/usePaymentTermsFormat';
import { useProductStringFormat } from '../../../../../common/hooks/useProductStringFormat';
import { Box } from '../../../../../common/ui/Box';
import { RfqOfferNoticeDaysDisplay } from '../../../components/RfqOfferCard/components/RfqOfferNoticeDaysDisplay';
import { useRfqOfferCardContext } from '../../../components/RfqOfferCard/hooks/useRfqOfferCardContext';

export const RfqOfferDetails = () => {
    const { offer } = useRfqOfferCardContext();
    const { getHumanReadableValue } = useEnums();
    const formatProductString = useProductStringFormat();
    const formatPaymentTerms = usePaymentTermsFormat();
    const activeItems = offer.items.filter((item) => !item.deleted);
    const products = activeItems
        .filter((item) => !item.isTranslationMissing() && item.productId)
        .map((item) => formatProductString(item.product!));
    const displayedProducts = products.length > 3 ? products.slice(0, 2) : products;

    return (
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={16} paddingTop={8} style={{ userSelect: 'none' }}>
            <Box display="flex" flexDirection="column" rowGap={4} alignItems="start">
                {displayedProducts.length
                    ? displayedProducts.map((product, index) => (
                          <Text key={`${product}-${index}`} variant="extraSmall">
                              {product}
                          </Text>
                      ))
                    : null}

                {products.length > displayedProducts.length ? (
                    <Text variant="extraSmall" color="accent.foreground">
                        {translate('order.detail.showMore')}
                    </Text>
                ) : null}
            </Box>

            <Box display="flex" flexDirection="column" rowGap={4} alignItems="start">
                <RfqOfferNoticeDaysDisplay
                    noticeDays={offer.noticeDays}
                    dateDelivery={offer.dateDelivery}
                    offerState={offer.state}
                />

                {offer.supplyMode ? (
                    <Tooltip label={translate('rfq.detail.offerCard.supplyMode')} showArrow side="right">
                        <Text variant="extraSmall">{getHumanReadableValue('supplyMode', offer.supplyMode)}</Text>
                    </Tooltip>
                ) : null}

                {offer.isSpot() && offer.paymentTermReference ? (
                    <Tooltip label={translate('order.detail.paymentTerm')} showArrow side="right">
                        <Text variant="extraSmall">
                            {formatPaymentTerms(offer.paymentTermReference, offer.paymentTermReferenceDays)}
                        </Text>
                    </Tooltip>
                ) : null}

                {offer.vendorReference ? (
                    <Tooltip label={translate('rfq.detail.offerCard.vendorReference')} showArrow side="right">
                        <Text variant="extraSmall">{offer.vendorReference}</Text>
                    </Tooltip>
                ) : null}
            </Box>
        </Box>
    );
};
